import '.h{display:grid;}.ssr-plugin'
import '.d{gap:1rem;}.ssr-plugin'
import { styled } from 'inlines'
import Column from '@app/components/layout/Column'
import { ReactNode } from 'react'
import { Image } from '@app/components/core/image/Image'
import { expandImage, type StoredImage } from '@app/types/StoredImage'

export type ImageOveriewProps = {
  images: (string | StoredImage)[]
  altFallback?: string
  header: ReactNode
  onImageClick: (index: number) => void
}

export const ImageOveriew = ({
  images,
  altFallback,
  header,
  onImageClick,
}: ImageOveriewProps) => {
  return (
    <Column alignItems="stretch" style={{ padding: '2rem' }}>
      {header}
      <div className="h d"
        style={{
          gridTemplateColumns: `repeat(${images.length > 2 ? '3' : '2'}, 1fr)`,
          gridTemplateRows: `repeat(${Math.trunc(Math.ceil(images.length / 3))}, 1fr)`,}}
      >
        {images.map((image, index) => {
          const { src, altText } = expandImage(
            image,
            altFallback ?? `Image ${index + 1}`,
          )
          if (!src) return null
          return (
            <div key={index}>
              <Image
                onClick={() => onImageClick(index)}
                src={src}
                resizeWidth={1000}
                alt={altText}
                style={{
                  width: '100%',
                  height: '100%',
                  aspectRatio: '1/1',
                  objectFit: 'cover',
                  borderRadius: '0.625rem',
                  display: 'block',
                }}
              />
            </div>
          )
        })}
      </div>
    </Column>
  )
}
